import React, {Fragment, Component} from 'react';
import {Typography, AccordionDetails} from "@mui/material";
import styles from "./Styles.module.css";

/**
 * @author: Chris Okebata
 */

const renderOrganizationPortalRow = (portal, classes, openModal) => {

  return(
    <AccordionDetails key={portal.id} className={styles.expansionPanelDetails}>
      <Typography className={styles.typography15}>
        {portal.displayLabel}
      </Typography>

      <div className={styles.portalActions}>
        <button
            className={`btn btn-default font-16 ${styles["viewButton"]}`}
            onClick={(e)=>{openModal(e, 'viewPortalModalStatus', portal)}}>
          View
        </button>
        <button
            className={`btn btn-info font-16  ${styles["editButton"]}`}
            onClick={(e)=>{openModal(e, 'editPortalModalStatus', portal)}}>
          Edit
        </button>
        <button
            className={`btn btn-danger font-16  ${styles["deleteButton"]}`}
            onClick={(e)=>{openModal(e, 'deletePortalModalStatus', portal)}}>
          Delete
        </button>
      </div>
    </AccordionDetails>
  );
};


class OrganizationPortal extends Component {

  render() {
    const { classes, portalArr, openModal } = this.props;
    return(
      <Fragment>
        {portalArr.map((portal) => renderOrganizationPortalRow( portal, classes, openModal))}
      </Fragment>
    )
  }
}

export { OrganizationPortal };